import store from "../store";
import { helpers } from "../utils";

const chatEventListener = (id, idle) => {
    return Echo.join('chat')
        .listen('MessageSentEvent', (e) => {
            // e.users.forEach(element => {
                helpers.eventBus.$emit('message-sent', e.room_id, e.user_id, e.message_id);
            // })
        })
        .listen('RoomOpenEvent', (e) => {
            if (e.user_id === id) {
                if ($('.chat-box-room-' + e.room_id).length === 0) {
                    helpers.eventBus.$emit('open-chat-room');
                }
            }
        })
        .listen('RoomCollapseEvent', (e) => {
            if (e.user_id === id) {
                helpers.eventBus.$emit('collapse-chat-room', e.room_id, e.is_collapsed);
            }
        })
        .listen('RoomClosedEvent', (e) => {
            if (e.user_id === id) {
                helpers.eventBus.$emit('close-chat-room', e.room_id);
            }
        })
        .listen('RoomUpdateEvent', (e) => {
            helpers.eventBus.$emit('update-chat-room', e.room);
        })
        .listen('RoomDeleteEvent', (e) => {
            helpers.eventBus.$emit('close-chat-room', e.room_id);
            helpers.eventBus.$emit('delete-chat-room');
        })
        .listen('UpdateUnReadRoom', (e) => {
            if (e.user_id === id) {
                helpers.eventBus.$emit('update-unread-room', e.room_id, e.un_read);
            }
        })
        .listen('UserStatus', (e) => {
            const currentStatus = store.state.activity.activity.status

            if (e.user_id === id) {
                if (e.status === 'offline') {
                    idle.reset({
                        idle: true,
                        //visible: ! document.hidden,
                    })
                }

                if (e.status && e.name && currentStatus !== e.status) {
                    // Dispatch Vuex action to update user status
                    store.dispatch('activity/setCurrentActivity', [e.status, e.name])
                }
            }

            /* Move user to their respective status */
            const userPresenceLists = store.state.presence.userPresenceLists
            const userPresence = _.find(_.flatMap(userPresenceLists, 'users'), { id: e.user_id })

            if (e.status && e.name && userPresence?.status !== e.status) {
                store.dispatch('presence/updateUsersPresence', e)
            }
            /**/

            /* Set timeout because there is a race condition here */
            setTimeout(() => {
                helpers.updateIconsUsersLists()
            }, 300)
            /**/
        })
        .listen('UpdateCoaching', (e) => {
            if (e.type === 'video_call') {
                let coach_status = $(".user-online-" + e.user_id + ".is-video-call").find('.coach-status')
                let chat_button = $('.card-chat-' + e.user_id).find('.video-call-coach')
                if (e.is_coachable) {
                    coach_status.addClass('is-' + e.customer_type)
                    chat_button.css('display', 'inline')
                    if (e.customer_type === 'student') {
                        chat_button.find('.coach-type').html('S')
                    } else if (e.customer_type === 'prospect') {
                        chat_button.find('.coach-type').html('P')
                    } else if (e.customer_type === 'lead') {
                        chat_button.find('.coach-type').html('L')
                    }
                } else {
                    chat_button.css('display', 'none')
                    helpers.removeClassRegex(/^is-/, coach_status)
                }
            } else if (e.type === 'call') {
                let coach_status = $(".user-online-" + e.user_id + ".is-call").find('.coach-status')
                let chat_button = $('.card-chat-' + e.user_id).find('.call-coach')
                if (e.is_coachable) {
                    coach_status.addClass('is-' + e.customer_type)
                    chat_button.css('display', 'inline')
                    if (e.customer_type === 'student') {
                        chat_button.find('.coach-type').html('S')
                    } else if (e.customer_type === 'prospect') {
                        chat_button.find('.coach-type').html('P')
                    } else if (e.customer_type === 'lead') {
                        chat_button.find('.coach-type').html('L')
                    }
                } else {
                    chat_button.css('display', 'none')
                    helpers.removeClassRegex(/^is-/, coach_status)
                }
            }
        })
        .error((error) => {
            console.error("Error details:", error);
            console.error("Echo error at channel chat.");
        })
}

export { chatEventListener }